var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 29.867,
    viewBox: "0 0 32 29.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "diamond-12",
    d: "M55.94,66.133l-5.6,6.4H60.789l-4.8-6.4Zm-15.9,0h-.049l-4.8,6.4H45.638Zm20.7,8.533H35.236l12.753,16.4ZM38.6,64.427A1.067,1.067,0,0,1,39.456,64H56.522a1.067,1.067,0,0,1,.853.427l6.4,8.533a1.067,1.067,0,0,1-.011,1.295l-14.933,19.2a1.067,1.067,0,0,1-1.685,0l-14.933-19.2A1.067,1.067,0,0,1,32.2,72.96Zm9.386,7.552L53.1,66.133H42.873Z",
    transform: "translate(-31.989 -64)",
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.3b400ae16061a5172e5c0d7c23730e5b.svg";
export { ForwardRef as ReactComponent };